// Definição para o modal de busca de Contas Bancárias (genérica)
// Variação de contaBancariaSearch para busca sem self-reference
// Factory function - recebe idEmpresa como parâmetro

export const criarConfigBuscaContaBancaria = (idOrganizacao) => ({
  label: 'Conta Bancária',
  placeholder: 'Descrição...',
  titulo: 'Pesquisar Conta Bancária',
  endpointApi: 'ContasBancarias',
  idField: 'idContaBancaria',
  displayField: 'idContaBancaria',
  descField: 'descricao',
  camposFiltro: [
    { label: 'Descrição', model: 'busca', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idContaBancaria', width: '15%' },
    { header: 'Descrição', dataField: 'descricao', width: '45%' },
    { header: 'Banco', dataField: 'nomeInstituicaoFinanceira', width: '40%' }
  ],
  filtrosFixos: { idOrganizacao }
})
